import { Categorias } from './../../classes/categorias';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-category-list',
  templateUrl: './category-list.component.html',
  styleUrls: ['./category-list.component.css'],
  standalone: false,
})
export class CategoryListComponent {
  @Input() categoryList: {
    col: string;
    grid: string;
    categories: Categorias[];
  };
}
